
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesforceUserItems"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesforceUser"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"witsbySubscriberStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"witsbyRole"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"witsbyPortfolioId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"welcomeEmailDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subjectAreas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schoolName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schoolId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"recoveryEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryAccountName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primaryAccountId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"personalPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"organizationType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oktaId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jobType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"grades"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"districtName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"districtId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contractGroupID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modalOff"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minutesPerWeek"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initialYearOfService"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":455}};
    doc.loc.source = {"body":"fragment SalesforceUserItems on SalesforceUser {\n  id\n  witsbySubscriberStatus\n  witsbyRole\n  witsbyPortfolioId\n  welcomeEmailDate\n  title\n  subscriptionType\n  subjectAreas\n  schoolName\n  schoolId\n  recoveryEmail\n  primaryAccountName\n  primaryAccountId\n  personalPhone\n  organizationType\n  oktaId\n  lastName\n  jobType\n  grades\n  firstName\n  email\n  districtName\n  districtId\n  contractGroupID\n  avatar\n  modalOff\n  minutesPerWeek\n  initialYearOfService\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SalesforceUserItems"] = oneQuery(doc, "SalesforceUserItems");
        
